import { AfterContentInit, Component, ContentChild, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { UserLoginComponent } from '../../../features/user/user-login/user-login.component';
import { UserRegisterComponent } from '../../../features/user/user-register/user-register.component';
import { Subscription } from 'rxjs';

const CLOSE_DEFAULT = 800;

@Component({
  selector: 'app-glass-modal',
  standalone: true,
  templateUrl: './glass-modal.component.html',
  styleUrl: './glass-modal.component.scss',
})
export class GlassModalComponent implements AfterContentInit, OnDestroy {
  @ContentChild(UserLoginComponent) loginComponent?: UserLoginComponent;
  @ContentChild(UserRegisterComponent) registerComponent?: UserRegisterComponent;

  @Input() closeDelay: number = CLOSE_DEFAULT;

  @ViewChild('dialog', { static: true }) dialog!: ElementRef<HTMLDialogElement>;

  #subscriptions = new Subscription();

  ngAfterContentInit(): void {
    if (this.loginComponent) {
      this.#subscriptions.add(this.loginComponent.loginSuccess.subscribe(() => this.handleSuccess()));
    }
    if (this.registerComponent) {
      this.#subscriptions.add(this.registerComponent.registrationSuccess.subscribe(() => this.handleSuccess()));
    }
  }

  ngOnDestroy(): void {
    this.#subscriptions.unsubscribe();
  }

  onDialogClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeCard();
    }
  }

  onDialogKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeCard();
    }
  }

  closeCard(): void {
    this.dialog.nativeElement.close();
  }

  openCard(): void {
    this.dialog.nativeElement.showModal();
    this.dialog.nativeElement.focus();
  }

  handleSuccess(): void {
    setTimeout(() => this.closeCard(), this.closeDelay);
  }
}
